import { render, staticRenderFns } from "./SendSmsMsg.vue?vue&type=template&id=05e8e0bb&scoped=true"
import script from "./SendSmsMsg.vue?vue&type=script&lang=js"
export * from "./SendSmsMsg.vue?vue&type=script&lang=js"
import style0 from "./SendSmsMsg.vue?vue&type=style&index=0&id=05e8e0bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e8e0bb",
  null
  
)

export default component.exports